// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2IWMqhvyx{cursor:pointer;text-decoration:inherit;color:inherit}\n", ""]);
// Exports
exports.locals = {
	"anchor": "_2IWMqhvyx"
};
module.exports = exports;
